import { render, staticRenderFns } from "./PuestosSueldos.vue?vue&type=template&id=64fb2c50&scoped=true"
import script from "./PuestosSueldos.vue?vue&type=script&lang=js"
export * from "./PuestosSueldos.vue?vue&type=script&lang=js"
import style0 from "./PuestosSueldos.vue?vue&type=style&index=0&id=64fb2c50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fb2c50",
  null
  
)

export default component.exports